import { lazy } from "react";

const InvoicePDF = lazy(() => import("../Component/BillingPDF/InvoicePDF"));
const ReceiptPDF = lazy(() => import("../Component/BillingPDF/ReceiptPDF"));
const CreditNote = lazy(() => import("../Component/BillingPDF/CreditNote"));
const RefundReceiptVoucher = lazy(() => import("../Component/BillingPDF/RefundReceiptVoucher"));

const billingRoutes = [
  { path: "/invoice/:leadId/:packageId/:serviceId", element: <InvoicePDF />, protected: false },
  { path: "/receipt-preview/:leadId/:packageId/:serviceId", element: <ReceiptPDF />, protected: false },
  { path: "/credit-note/:leadId/:packageId/:serviceId", element: <CreditNote />, protected: false },
  { path: "/refund-receipt-voucher/:leadId/:packageId/:serviceId", element: <RefundReceiptVoucher />, protected: false },
];

export default billingRoutes;
